import Vue from 'vue'

const state = {
  userSettings: {
    "user": {
      "name_user": "",
      "email": "",
      "target_score": "",
      "now_score": "",
    },
    "using_plan": {
      "expires_date": "",
      "name_plan": "",
      "product_id": "",
      "purchase_date": "",
      "auto_renewal": ""
    }
  },
};

const mutations = {
  'SET_USER_SETTINGS' (state, userSettings) {
    state.userSettings = userSettings;
  },
  'SET_AUTO_RENEWAL' (state, auto_renewal) {
    state.userSettings.using_plan.auto_renewal = auto_renewal;
  },
  'SET_SUBSCRIPTIONS' (state, subscriptions) {
    state.userSettings.subscriptions = subscriptions;
  },
};

const actions = {
  getUpgradeStatus: ({commit}, info) => {
    return Vue.http.get('webstore/user/status/upgraded?token=' + info.token)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (data.error) {
          return 'error';
        }
        return data;
      })
      .catch(() => {
        return 'error';
      });
  },
  getUserSettings: ({commit}, info) => {
    return Vue.http.get('webstore/user/status?token=' + info.token)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (data.error) {
          return 'error';
        }
        commit('SET_USER_SETTINGS', data);
        return data;
      })
      .catch(() => {
        return 'error';
      });
  },
  updateUserSettings: ({commit}, order) => {
    return Vue.http.post('webstore/user/update', order)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      })
      .then(data => {
        if (data.error) {
          alert("通信に失敗しました。再度、更新を行ってください。")
          return 'error';
        }
        return data;
      })
      .catch(err => {
        alert("通信に失敗しました。再度、更新を行ってください。")
        return 'error';
      });
  },
  updatePaymentsWay: ({commit, dispatch}, order) => {
    return Vue.http.post('webstore/user/update/payment_type', order)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      })
      .then(data => {
        if (data.message) {
          return 'error';
        }
        return data;
      })
      .catch(err => {
        return 'error';
      });
  },
  unsubscribe: ({commit, dispatch}, order) => {
    return Vue.http.post('webstore/user/unsubscribe', order)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      })
      .then(data => {
        return data;
      });
  },
  setAutoRenewal: ({commit}, auto_renewal) => {
    commit('SET_AUTO_RENEWAL', auto_renewal);
  },
  setSubscriptions: ({commit}, subscriptions) => {
    commit('SET_SUBSCRIPTIONS', subscriptions);
  },
};

const getters = {
  userSettings: state => {
    return state.userSettings;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js